<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/comment' }">
        <app-i18n code="entities.comment.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.comment.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.comment.view.title"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

      <app-comment-view-toolbar v-if="record"></app-comment-view-toolbar>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        @submit.prevent.native
        class="form"
        v-if="record"
      >
        <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

        <app-view-item-relation-to-one
          :label="fields.admin.label"
          :permission="fields.admin.readPermission"
          :url="fields.admin.viewUrl"
          :value="presenter(record, 'admin')"
        ></app-view-item-relation-to-one>

        <app-view-item-text :label="fields.comment.label" :value="presenter(record, 'comment')"></app-view-item-text>

        <app-view-item-text :label="fields.status.label" :value="presenter(record, 'status')"></app-view-item-text>

        <app-view-item-text :label="fields.createdAt.label" :value="presenter(record, 'createdAt')"></app-view-item-text>

        <app-view-item-text :label="fields.updatedAt.label" :value="presenter(record, 'updatedAt')"></app-view-item-text>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CommentViewToolbar from '@modules/comment/components/comment-view-toolbar.vue';
import { CommentModel } from '@modules/comment/comment-model';

const { fields } = CommentModel;

export default {
  name: 'app-comment-view-page',

  props: ['id'],

  components: {
    [CommentViewToolbar.name]: CommentViewToolbar,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'comment/view/record',
      loading: 'comment/view/loading',
    }),

    fields() {
      return fields;
    },
  },

  async created() {
    await this.doFind(this.id);
  },

  methods: {
    ...mapActions({
      doFind: 'comment/view/doFind',
    }),

    presenter(record, fieldName) {
      return CommentModel.presenter(record, fieldName);
    },
  },
};
</script>
